export const activityLogsConstants = {
  FETCH_ACTIVITY_LOGS: "FETCH_ACTIVITY_LOGS",
  AND: " AND ",
  OR: " OR ",
};

export const ACTIVITY_LOG_MESSAGE_DELIMITER = "::";

export const ACTIVITY_LOG_COLUMN_HEADERS = Object.freeze({
  ACTION: "ACTION",
  LOG_TYPE: "LOG TYPE",
  BRAND_ID: "BRAND ID",
  DATE_TIME: "DATE TIME",
  USER_NAME: "USER NAME",
  USER_TYPE: "USER TYPE",
  LOG_DETAIL: "LOG DETAIL",
  BRAND_NAME: "BRAND NAME",
});

export const logTypeList = [
  {
    id: 1,
    name: "Info",
    value: "Info",
  },
  {
    id: 2,
    name: "Error",
    value: "Error",
  },
];
